import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nomination-sanction-grid',
  templateUrl: './nomination-sanction-grid.component.html',
  styleUrls: ['./nomination-sanction-grid.component.css']
})
export class NominationSanctionGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Nomination/nomination-sanction/nomination-sanction-grid/nomination-sanction-grid.component.ts